// extracted by css-extract-rspack-plugin
export default {"cancelSuccessBanner":"cancelSuccessBanner-mPniBX"};